import axios from 'axios'

export const getNotifyCount = () => axios.get('/trip-notify/msg/v2/count')

export const getCategoryList = (type) => axios.get(`/trip-notify/msg/list/category?typeId=${type || 0}`)

export const getList = (params) => axios.get('/trip-notify/msg/condition/list', { params })

export const readAllMessage = (types) => axios.put('/trip-notify/msg/types/read', {typeIds: types.join(',') })

export const handleMsg = (msgId) => axios.put('/trip-notify/msg/ids/handled', { broadCastIds: msgId })

export const update = (msg) => axios.post('/trip-notify/msg/status/update', msg)

export const getType = () => axios.get('/trip-notify/msg/type')

export const pageList = (params) => axios.get('/trip-notify/msg/condition/page', { params })

export const noticeList = (params) => axios.get('/trip-notify/acc/announces', { params })

export const getLastestMsg = (typeWeight) => axios.get('/trip-notify/msg/latest', { params: { typeWeight: typeWeight }})

export const insertCookie = () => axios.get('/trip-notify/acc/cookie')


// WEBPACK FOOTER //
// ./src/api/tripNotify.js